import type { PageMeta } from '../../../lib/permissions/pageMeta'
import PurchaseReturnsPage from '../../purchases/PurchaseReturnsPage'

export const pageMeta: PageMeta = {
  key: 'buy.returns',
  label: 'Purchase Returns',
  module: 'Trading',
  section: 'Buy',
  description: 'Process returns to suppliers',
  defaultPermissions: {
    owner: 'edit', admin: 'edit', manager: 'edit',
    accountant: 'view', cashier: 'none', viewer: 'view',
  },
  hasVisibility: true,
  ownerColumn: 'created_by',
}

export default function BuyReturnsTab() {
  return <PurchaseReturnsPage />
}
